var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.breadcrumb),function(item,index){return _c('el-breadcrumb-item',{key:item.path,attrs:{"breadcrumb":_vm.breadcrumb}},[_c('a',{attrs:{"href":item.path}},[_vm._v(_vm._s(item.meta.title))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }